import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import productValues1 from '../../photos/productValues1.svg';
import productValues2 from '../../photos/productValues2.svg';
import productValues3 from '../../photos/productValues3.svg';
import productValues4 from '../../photos/productValues4.svg';

const values = [
  {
    icon: productValues1,
    highlight: '18 років',
    text: 'у сфері логістики',
    modalTitle: '18 років досвіду',
    modalText: 'За 18 років роботи ми здійснили понад 15 000 успішних перевезень по Україні та Європі. Наша база нараховує більше 12 000 перевірених та надійних водіїв, кожен з яких пройшов ретельний відбір. Ми знаємо кожен маршрут, кожну митницю та кожен нюанс вантажоперевезень.',
  },
  {
    icon: productValues2,
    highlight: '1 година',
    text: 'організація перевезення',
    modalTitle: 'Швидка організація',
    modalText: 'Напишіть або зателефонуйте нам, і ми прорахуємо оптимальний маршрут для вашого вантажу протягом години. Підберемо потрібний тип транспорту, розрахуємо вартість та терміни доставки.',
    modalLink: { text: 'Зателефонувати', href: 'tel:+380966341617' },
  },
  {
    icon: productValues3,
    highlight: '100%',
    text: 'матеріальна відповідальність',
    modalTitle: '100% відповідальність',
    modalText: 'Ми гарантуємо повну цілісність вашого вантажу від упаковки до кінцевої точки доставки. Кожне перевезення застраховано. Постійний GPS-контроль, зв\'язок з водієм, фотофіксація завантаження та вивантаження. Ваш вантаж під надійним захистом на кожному етапі.',
  },
  {
    icon: productValues4,
    highlight: 'Міжнародна',
    text: 'логістика',
    modalTitle: 'Україна та Європа',
    modalText: 'Здійснюємо перевезення по всій Україні та країнах Європи: Польща, Румунія, Чехія, Словаччина, Угорщина, Молдова, Болгарія, Литва, Латвія, Естонія, Німеччина, Австрія, Італія, Франція, Нідерланди, Бельгія. Повний митний супровід та оформлення документів.',
  },
];

function ProductValues() {
  const sectionRef = useRef(null);
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.value-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (activeModal !== null) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [activeModal]);

  return (
    <>
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: '#0a0a0f',
      position: 'relative',
    }}>
      {/* Parallax gradient orb */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'min(600px, 100vw)',
        height: 'min(600px, 100vw)',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(22,183,36,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Чому <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>обирають нас</span>
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: 24,
        }}>
          {values.map((val, i) => (
            <div key={i} className="value-card" style={{
              opacity: 0,
              transform: 'translateY(40px)',
              transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
              padding: 36,
              borderRadius: 20,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              textAlign: 'center',
              cursor: 'pointer',
            }}
            onClick={() => setActiveModal(i)}
            onMouseOver={e => {
              e.currentTarget.style.background = 'rgba(22,183,36,0.08)';
              e.currentTarget.style.borderColor = 'rgba(22,183,36,0.3)';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 20px 60px rgba(22,183,36,0.1)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <div style={{
                width: 70,
                height: 70,
                borderRadius: '50%',
                background: 'rgba(22,183,36,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
              }}>
                <img src={val.icon} alt="" style={{ height: 32, filter: 'brightness(0) invert(1)' }} />
              </div>
              <div style={{
                fontSize: 28,
                fontWeight: 700,
                background: 'linear-gradient(135deg, #16b724, #4dc247)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: 8,
              }}>
                {val.highlight}
              </div>
              <div style={{
                fontSize: 15,
                color: 'rgba(255,255,255,0.6)',
                lineHeight: 1.5,
              }}>
                {val.text}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes valModalIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes valCardIn {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </section>

    {/* Modal */}
    {activeModal !== null && ReactDOM.createPortal(
      <div
        onClick={() => setActiveModal(null)}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10000,
          background: 'rgba(0,0,0,0.85)',
          backdropFilter: 'blur(12px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          animation: 'valModalIn 0.3s ease',
        }}
      >
        <div
          onClick={e => e.stopPropagation()}
          style={{
            background: 'linear-gradient(180deg, #111518 0%, #0a0f0a 100%)',
            border: '1px solid rgba(77,194,71,0.15)',
            borderRadius: 24,
            maxWidth: 480,
            width: '100%',
            padding: '40px 36px',
            animation: 'valCardIn 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
            position: 'relative',
          }}
        >
          <button
            onClick={() => setActiveModal(null)}
            style={{
              position: 'absolute',
              top: 16,
              right: 16,
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#fff',
              fontSize: 18,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ✕
          </button>

          <div style={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            background: 'rgba(22,183,36,0.1)',
            border: '2px solid rgba(22,183,36,0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
          }}>
            <img src={values[activeModal].icon} alt="" style={{ height: 36, filter: 'brightness(0) invert(1)' }} />
          </div>

          <h3 style={{
            fontSize: 24,
            fontWeight: 700,
            color: '#fff',
            textAlign: 'center',
            marginBottom: 20,
          }}>
            {values[activeModal].modalTitle}
          </h3>

          <p style={{
            fontSize: 15,
            color: 'rgba(255,255,255,0.7)',
            lineHeight: 1.8,
            textAlign: 'center',
            marginBottom: values[activeModal].modalLink ? 24 : 0,
          }}>
            {values[activeModal].modalText}
          </p>

          {values[activeModal].modalLink && (
            <div style={{ textAlign: 'center' }}>
              <a
                href={values[activeModal].modalLink.href}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                  color: '#fff',
                  fontSize: 15,
                  fontWeight: 600,
                  textDecoration: 'none',
                  borderRadius: 50,
                  textTransform: 'uppercase',
                  letterSpacing: '0.03em',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 20px rgba(22,183,36,0.3)',
                }}
              >
                {values[activeModal].modalLink.text}
              </a>
            </div>
          )}
        </div>
      </div>,
      document.body
    )}
    </>
  );
}

export default ProductValues;
